import graphScanCount from './graph-scan-count.container';

export default graphScanCount;
